import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'
import queryString from 'query-string'
import { useScormEnrolmentQuery } from 'front-end/src/pages/scorm-page/operations/Scorm.codegen'

export const useGetScormQuery = (
  topicEnrolmentId: number,
  queryOptions?: any
) => {
  if (queryOptions?.skip) {
    return { link: '' }
  }
  const { session } = usePublicApiSession()

  const qs = queryString.stringify({
    custom_1: session?.user?.custom_1 || '',
    custom_2: session?.user?.custom_2 || '',
    custom_3: session?.user?.custom_3 || ''
  })

  const queryResult = useScormEnrolmentQuery({
    variables: {
      id: topicEnrolmentId,
      redirect: `${window.location.href.split('?')[0]}`
    },
    fetchPolicy: 'network-only',
    ...queryOptions
  })

  return {
    ...queryResult,
    link:
      `${queryResult.data?.enrolment?.getOrCreateScormRegistration?.launchLink}&${qs}` ||
      ''
  }
}
